import type { SetState } from '../store';

export type GameWindowsSliceProps = {
    gameWindows: Window[];
    addGameWindow: (gameWindow: Window) => void;
    clearGameWindows: () => void;
};

export const gameWindowsSlice = ({ set }: SetState<GameWindowsSliceProps>): GameWindowsSliceProps => ({
    gameWindows: [],

    addGameWindow: (gameWindow: Window) => {
        set((state) => ({
            gameWindows: [...state.gameWindows, gameWindow]
        }));
    },

    clearGameWindows: () => {
        set(() => ({
            gameWindows: []
        }));
    }
});
